import Layout from '@/layout/index.vue'

export const NotificationSubscriptionRoute = {
  path: '/notification-subscription',
  component: Layout,
  children: [
    {
      path: '',
      component: (): Promise<any> =>
        import(
          /* webpackChunkName: "users-index" */
          '@/features/notification-subscription/views/index.vue'),
      name: 'NotificationSubscriptionIndexRoute',
      meta: {
        title: 'NotificationSubscriptionIndexRouteTitle',
        requiresAuth: true
      }
    }
  ]
}
